import { SERVICE_GRID } from "../../../../../constants/serviceGrid";

const SelectedServicesHeader = () => (
  <div className="sticky top-0 z-10 shrink-0 rounded-tl-lg rounded-tr-lg border-b bg-white">
    <div
      className={`mx-4 grid ${SERVICE_GRID} items-center px-4 py-3 text-xs font-semibold text-gray-600 sm:text-sm`}
    >
      <div className="text-center">STT</div>
      <div className="text-center">Tên dịch vụ</div>
      <div className="text-center">Số lượng</div>
      <div className="text-center">Phí đăng ký</div>
      <div className="text-center">Phí cấp bằng</div>
      <div className="text-center">VAT (%)</div>
      <div className="text-center">Thành tiền</div>
      <div className="text-center">Thao tác</div>
    </div>
  </div>
);

export default SelectedServicesHeader;
